import { Box, Link } from "@material-ui/core";
import React from "react";
import { useSelector } from "store";

import type { FC, SVGAttributes } from "react";
import type { Store } from "store";

export const StreamingAnnouncementForFullscreen: FC<{
  streamingType: "Live" | "VOD";
  isAdmin: boolean;
  isOpenAnnouncement: boolean;
  streamingAnnouncement: string;
  handleCloseAnnouncement: () => void;
}> = ({
  streamingType,
  isAdmin,
  isOpenAnnouncement,
  streamingAnnouncement,
  handleCloseAnnouncement,
}) => {
  const isDarkModeEnabled = useSelector(
    (state: Store) => state.streaming.streamingSettings.isDarkModeEnabled
  );

  if (streamingType === "VOD") {
    return null;
  }

  if (!isAdmin && streamingAnnouncement === "") {
    return null;
  }

  if (!isOpenAnnouncement) {
    return null;
  }

  return (
    <StreamingAnnouncementForFullscreenView
      streamingAnnouncement={streamingAnnouncement}
      isDarkModeEnabled={isDarkModeEnabled}
      handleCloseAnnouncement={handleCloseAnnouncement}
    />
  );
};

export const StreamingAnnouncementForFullscreenView: FC<{
  streamingAnnouncement: string;
  isDarkModeEnabled: boolean;
  handleCloseAnnouncement: () => void;
}> = ({
  streamingAnnouncement,
  isDarkModeEnabled,
  handleCloseAnnouncement,
}) => {
  return (
    <Box
      position={"relative"}
      display={"grid"}
      gridTemplateColumns={"max-content 1fr max-content"}
      gridGap={"4px"}
      padding={"0.5rem"}
      color={isDarkModeEnabled ? "dark.icon.primary" : "light.icon.primary"}
      bgcolor={isDarkModeEnabled ? "#303030" : "#f0f0f0"}
      borderRadius={"0.75rem"}
    >
      {/* メガホンアイコン */}
      <Box>
        <AnnouncementIcon width={"24px"} height={"24px"} />
      </Box>

      {/* アナウンス内容 */}
      <Box fontSize={"14px"}>
        <FormattedTextWithLink text={streamingAnnouncement} />
      </Box>

      {/* 閉じるボタン */}
      <Box
        aria-label="閉じる"
        style={{ cursor: "pointer" }}
        onClick={handleCloseAnnouncement}
      >
        ×
      </Box>
    </Box>
  );
};

type FormattedTextWithLinkProps = {
  text: string;
};
const FormattedTextWithLink: FC<FormattedTextWithLinkProps> = ({ text }) => {
  // より包括的なURLを検出する正規表現
  const urlRegex = /(https?:\/\/(?:www\.)?[^\s<>[\]{}|\\^`]+)/gi;

  // テキストをURLで分割
  const parts: string[] = text.split(urlRegex);

  return (
    <>
      {parts.map((part: string, index: number) => {
        // URLかどうかをチェック
        if (urlRegex.test(part)) {
          return (
            <Link
              key={index}
              href={part}
              target="_blank"
              rel="noopener noreferrer"
              color="primary"
              underline="hover"
              title={part} // ホバー時に完全なURLを表示
              style={{ color: "#3182ce" }}
            >
              {part}
            </Link>
          );
        }
        return part;
      })}
    </>
  );
};

const AnnouncementIcon: FC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <g clipPath="url(#clip0_2639_29123)">
        <path d="M7.01211 7.875C5.34899 7.875 4 9.22198 4 10.8841C4 12.5447 5.34899 13.8917 7.01211 13.8917H7.53027V19.0451C7.53027 19.2884 7.72697 19.4848 7.97064 19.4848H10.6525C10.8961 19.4848 11.0928 19.2884 11.0928 19.0451V8.31471C11.0928 8.0714 10.8961 7.875 10.6525 7.875H7.01211Z" />
        <path d="M19.2877 4.61193C17.3354 6.16557 15.0792 7.30296 12.6602 7.9464V13.818C15.0792 14.4614 17.3354 15.5988 19.2877 17.1525C19.5754 17.3811 19.9996 17.1745 19.9996 16.808V11.3879V10.3751V4.95783C19.9996 4.59141 19.5754 4.38475 19.2877 4.61339V4.61193Z" />
      </g>
      <defs>
        <clipPath id="clip0_2639_29123">
          <rect width="16" height="14.9677" transform="translate(4 4.5166)" />
        </clipPath>
      </defs>
    </svg>
  );
};
